import { render, staticRenderFns } from "./VoiceFormattingButton.vue?vue&type=template&id=1c3b9499&scoped=true&"
import script from "./VoiceFormattingButton.vue?vue&type=script&lang=js&"
export * from "./VoiceFormattingButton.vue?vue&type=script&lang=js&"
import style0 from "./VoiceFormattingButton.vue?vue&type=style&index=0&id=1c3b9499&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3b9499",
  null
  
)

export default component.exports